import { findScenceByVersionForCustomer } from '@/api/query/scene';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { useState, useContext, useMemo, useEffect } from 'react';
import { useMutation } from 'react-query';
import { Scene } from '../../../types/Scene';
import { CustomerDataContext } from '@/common/components/layout/productLayout/context/CustomerDataContext';

const useIntroductionScreen = (id: string) => {
	const [scene, setScene] = useState<Scene>();
	const { userData } = useContext(CustomerDataContext);
	const langData = useLanguageData('features.sceneV3');

	const scenePayload = useMemo(
		() => ({ _id: id, version: 'V3', type: 'SCENE', sceneId: id }),
		[id],
	);

	const handleLoadLessonMutation = useMutation({
		mutationFn: (value: any) => findScenceByVersionForCustomer(value),
		onSuccess: ({ data }) => {
			setScene(data);
		},
	});

	useEffect(() => {
		window.document.title = `Synthi Ai - Scene`;

		if (!id) return;
		handleLoadLessonMutation.mutate(scenePayload);
	}, [id]);

	return {
		scene,
		userData,
		langData,
	};
};

export default useIntroductionScreen;
